export default {
  SET_UNMAPPED_USERS (state, users) {
    state.unmappedUsers = users
  }
}
